import JustValidate from 'just-validate';


function validateForm(unmForm) {

  const validator = new JustValidate(unmForm, {
    validateBeforeSubmitting: true,
    focusInvalidField: true,
  });


  Array.from(unmForm.querySelectorAll('.form-group')).forEach(fieldBox => {
    const field = fieldBox.querySelector('[name]');
    const rules = [];

    if (field.dataset.validateRules) {

      field.dataset.validateRules.split(',').forEach(rule => {

        if (rule === 'regex') {
          rules.push({
            rule: 'customRegexp',
            value: field.dataset.validatePattern,
            errorMessage: field.dataset.validateMessage,
          })

        } else if (rule === 'email') {

          rules.push({
            rule: 'email',
            // errorMessage: 'valid email!'
          })

          rules.push({
            validator: (value) => () => {

              const emailData = new FormData();
              emailData.append('email', value)

              if (!value.trim()) {
                return new Promise((resolve, reject) => {
                  return resolve(true)
                });
              }

              return fetch('/accounts/registration/uniqueV2', {
                method: 'POST',
                mode: "cors",
                credentials: "same-origin",
                headers: {
                  'X-Requested-With': 'XMLHttpRequest',
                },
                body: emailData
              })
                .then(response => response.json())
                .then(function (result) {

                  if (result.isUnique) {
                    return true
                  }
                  return false
                })
                .catch(function (error) {
                  console.log('Form validate error', error)
                  return true
                })

            },
            errorMessage: 'Email already exists!'
          })

        } else if (rule === 'minLength') {
          rules.push({
            rule: 'minLength',
            value: 8,
          })
        } else if (rule === 'password_repeat') {
          rules.push({
            validator: (value, fields) => {

              if (unmForm.querySelector('[name="password"]')) {

                const passwordValue = unmForm.querySelector('[name="password"]').value
                return value === passwordValue;

              }

              return true;
            },
            errorMessage: 'Passwords should be the same',
          })
        } else if (rule === 'integer') {
          rules.push({
            rule,
            errorMessage: 'This field should contain only numbers'
          })

        } else {
          rules.push({ rule })
        }

      })

      const errorContainer = {
        errorsContainer: document.querySelector(field.dataset.validateErrorContainer)
      }
      errorContainer.errorsContainer ? validator.addField(field, rules, errorContainer) : validator.addField(field, rules, null);

      if (field.dataset.validateRules.indexOf('email') !== -1) {
        field.addEventListener('blur', (e) => validator.revalidate())
      }

    }
  })

  return validator
}

export {validateForm}